module.exports = __webpack_public_path__ + "static/img/20.5e78d6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/20.jpg
// module id = tfgH
// module chunks = 1